// Dependencies
import React, { useEffect, useState, useRef } from "react";
import { Button, Grid, TextField } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Helmet } from "react-helmet";
import Cookies from 'universal-cookie';
import TagManager from 'react-gtm-module';
import base64decode from 'base-64';

// Helpers
import { loadFornecedores } from "./helpers/helpers_fornecedores";
import { loadAlfas } from "./helpers/helpers_alfas";
import { loadIds } from "./helpers/helpers_ids";

// Components
import { InstructionsCard } from "../childrens/InstructionsCard";
import { SelectMultiCheckbox } from "../childrens/Selects/SelectMultiCheckbox";
import { SelectAutoComplete } from "../childrens/Selects/SelectAutoComplete";
import { Table } from "../childrens/Table";
import { FileUpload } from "../childrens/FileUpload";
import ModalFichaTecnicaSucesso from "../../tabs/childrens/modals/modalFichaTecnicaSucesso/.mixins/index";
import Cabecario from "../../../../../../../util/cabecario/.mixins/index";
import Alerta from "../../../../../../../util/snackbars/.mixins";

//controllers
import Qualidade_controller from '../../../../../../../../controllers/qualidade';

// Style
import { css } from "./styles";

export const AdicionarFichaTecnica = () => {
    const styles = css();

    const [ficha, setFicha] = useState("");
    const [fornecedor, setFornecedor] = useState(null);

    const [fornecedores, setFornecedores] = useState([]);

    const [currentAlfa, setCurrentAlfa] = useState("");
    const [alfas, setAlfas] = useState([]);

    const [ids, setIds] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);

    const [produtos, setProdutos] = useState([]);

    const [isAlfasSelectDisabled, setIsAlfasSelectDisabled] = useState(true);
    const [isIdsSelectDisabled, setIsIdsSelectDisabled] = useState(true);
    const [isTableVisible, setIsTableVisible] = useState(false);

    const [openModalUpFichaTecnica, setOpenModalUpFichaTecnica] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false);

    const childAlert = useRef(null);

    useEffect(() => {
        getFornecedores();
    }, []);

    async function getFornecedores() {
        const r_fornecedores = await loadFornecedores();
        setFornecedores(r_fornecedores);
    }

    async function handleChangeSelectFornecedores(e, pfornecedor) {
        if (pfornecedor) {
            setIsAlfasSelectDisabled(false);
            const r_alfas = await loadAlfas(pfornecedor.id);
            const arrayItens = r_alfas.map(element => {
                return {
                    id: element[1],
                    nome: element[0],
                    idDescr: element[2],
                };
            });
            setAlfas(arrayItens);
            setFornecedor(pfornecedor);
        }
    }

    async function handleChangeSelectAlfas(e, alfa) {
        if (alfa) {
            setSelectedIds([]);
            setCurrentAlfa(alfa.nome);
            setIsIdsSelectDisabled(false);
            const r_ids = await loadIds(alfa.nome);
            setIds(r_ids);
        }
    }

    function handleClickAdicionarProdutos() {
        const idsProduto = produtos.map((produto) => produto.key);
        const idsSelected = selectedIds.map((selectedId) => selectedId);
        const faltamAdicionar = idsSelected.filter((selected) => !idsProduto.includes(selected.id));

        if (faltamAdicionar.length > 0) {
            setProdutos([...produtos, ...transformObject(faltamAdicionar)]);
            setIsTableVisible(true);
        }
    }

    function transformObject(array) {
        return array.map((item) => {
            return {
                key: item.id,
                alfa: currentAlfa,
                id: `${item.id} - ${item.nome}`,
                ficha,
                idDescr: item.idDescr,
            };
        });
    }

    function handleRemoverProduto(index, key) {
        const idsSelected = selectedIds.map((selectedId) => selectedId.id);
        const indexOf = idsSelected.indexOf(key);

        if (indexOf !== -1) {
            const newSelectedIds = selectedIds.filter((item, i) => i !== indexOf);
            setSelectedIds(newSelectedIds);
        }

        const newProdutos = produtos.filter((item, i) => i !== index);
        setProdutos(newProdutos);
    }

    async function handleEnviarFicha() {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if (ficha == null || ficha === "") {
            childAlert.current.retorno('Necessário vincular uma ficha!','warning');
            return;
        }

        if (fornecedor == null) {
            childAlert.current.retorno('Necessário vincular um fornecedor!','warning');
            return;
        }

        if (produtos.length === 0) {
            childAlert.current.retorno('É necessário adicionar pelo menos UM produto!','warning');
            return;
        }

        if (document.getElementById("upload-file-input").files.length === 0) {
            childAlert.current.retorno('Arquivo precisa ser anexado!','warning');
            return;
        }

        const file = document.getElementById("upload-file-input").files[0];
        
        if (file.type === "") {
        childAlert.current.retorno('É necessário especificar uma extensão ao arquivo!','warning');
            return;
        }
        if ((file.size / 1024 / 1024) >= 7) {
            childAlert.current.retorno('Tamanho máximo de arquivo 7mb','warning');
            return;
        }
        
        if (file.type !== "application/pdf") {
            childAlert.current.retorno('Extensão precisa ser pdf!','warning');
            return;
        }

        const formData = new FormData();
        const base64 = await toBase64(file);
        formData.append("Alfanumerico", ficha);
        formData.append("FileName", file.name);
        formData.append("ContentFile", file.type);
        formData.append("Doc", base64.split(",")[1]);
        formData.append("idUserFornecedor", fornecedor.id);
        formData.append("Departamento", "A");
        formData.append("InStatus", "A");
        const listProd = produtos.map(e=>{
            return({
                idDescr: e.idDescr,
                Nr_prod: e.key
            })
        });
        formData.append("ListaProd", JSON.stringify(listProd));

        TagManager.dataLayer({
            dataLayer: {
                event: 'event',
                eventCategory: 'tokstok:fornecedores:qualidade',
                eventAction: 'clique:botao',
                eventLabel: `enviar-ficha-${ficha}`,
            }
        });

        try {
          const o_qualidade = await Qualidade_controller.postFileAcessorios(token,formData);
          if (o_qualidade.status == 200) {
            await setOpenModalUpFichaTecnica(true);

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:qualidade',
            //       eventAction: 'callback',
            //       eventLabel: `sucesso`,
            //     }
            // });

          } else {
              const j_o_qualidade = await o_qualidade.json();
              if (j_o_qualidade && j_o_qualidade.message != null) {
                  childAlert.current.retorno(j_o_qualidade.message,'error');
              }

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:qualidade',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${j_o_qualidade.message}`,
            //     }
            // });

            return;
          }
        } catch (error) {
          console.error(error);
        }
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    function handleModalCloseUpFichaTecnica() {
        setOpenModalUpFichaTecnica(false);
        setTimeout(() => {
            document.location.reload(true);
        }, 500);
    }

    function handleGoBack() {
        window.location.href = "../#/qualidade";
    }

    return (
        <div>
            <Helmet>
                <title>{`${process.env.REACT_APP_TITLE} - Adicionar Ficha Técnica`}</title>
            </Helmet>

            <Cabecario title="Adicionar Ficha Técnica" goBack={handleGoBack} />

            <Grid className={styles.root} container spacing={2}>
                <Grid className={styles.input_grid} item xs={12}>
                    <TextField
                        InputLabelProps={{ className: styles.label }}
                        inputProps={{ className: styles.input }}
                        variant="outlined"
                        label="Número da ficha"
                        value={ficha}
                        onChange={(e) => setFicha(e.target.value)}
                    />

                    <SelectAutoComplete
                        itens={fornecedores}
                        onChange={handleChangeSelectFornecedores}
                        label="Fornecedor"
                    />
                </Grid>

                <Grid item xs={12}>
                    <InstructionsCard />
                </Grid>

                <Grid className={styles.input_grid} item xs={12}>
                    <SelectAutoComplete
                        itens={alfas}
                        disabled={isAlfasSelectDisabled}
                        onChange={handleChangeSelectAlfas}
                        label="Alfa numérico"
                    />

                    <SelectMultiCheckbox
                        itens={ids}
                        disabled={isIdsSelectDisabled}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                    />
                </Grid>

                <Grid item xs={12} style={{ display: "flex" }}>
                    <Grid item xs={8}>
                        {isTableVisible && (
                            <Table
                                produtos={produtos}
                                handleRemoverProduto={handleRemoverProduto}
                            />
                        )}
                        <FileUpload uploadStatus={uploadStatus} setUploadStatus={setUploadStatus} />
                    </Grid>

                    <Grid item xs={4} className={styles.adicionar_produto}>
                        {!isIdsSelectDisabled && (
                            <Button
                                onClick={handleClickAdicionarProdutos}
                                startIcon={<Add />}
                                variant="text"
                                color="primary"
                                component="span"
                            >
                                Adicionar produtos
                            </Button>
                        )}
                    </Grid>
                </Grid>

                <Grid item xs={12} className={styles.button_enviar_ficha}>
                    <Button
                        onClick={handleEnviarFicha}
                        variant="contained"
                        color="primary"
                        style={{ width: "255px" }}
                    >
                        Enviar ficha
                    </Button>
                </Grid>

                <ModalFichaTecnicaSucesso
                    isModalOpen={openModalUpFichaTecnica}
                    handleDialogModal={handleModalCloseUpFichaTecnica}
                />
            </Grid>

            <Alerta ref={childAlert}/>
        </div>
    );
};
